import CampaignsMainViewDataLoader from './CampaignsMainViewDataLoader';
export default CampaignsMainViewDataLoader;
